export abstract class DataHelper {
	static groupBy(datas: Array<any>, property: string): Array<any> {
		let t = datas.reduce((acc, current) => {
			if (acc[current[property]] = acc[current[property]] || []) {
				acc[current[property]].push(current);
			}
			return acc;
		}, {});
		return (<any>Object).values(t);
	}

	static replace(match: Array<string>, target: Object | string) {
		let string: string;
		(typeof target === 'object' ? string = JSON.stringify(target) : string = target)

		for (let i = 0; i < match.length; i++) {
			let s = match[i].split(':');
			(string.search(`%${s[0]}%`) === -1 ? s.reverse() : '');
			string = string.replace(new RegExp(`%${s[0]}%`, "g"), s[1]);
		}
		return (typeof target === 'object' ? JSON.parse(string) : string)
	}

	static sortBy(datas: Array<any>, property: string, reverse: boolean = false): Array<any> {

		let result = datas.sort((a, b) => {
			a = this.resolveObjectPath(a, property)
			b = this.resolveObjectPath(b, property)

			if (a > b) {
				return 1;
			}
			if (a < b) {
				return -1;
			}
			return 0;
		});


		if (reverse)
			result.reverse()

		return result
	}


	static resolveObjectPath(obj, keys) {
		return keys.split('.').reduce(function(cur, key) {
			return cur[key];
		}, obj);
	}
}
